import { NgTemplateOutlet } from '@angular/common';
import { Component, input } from '@angular/core';

import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'wcg-empty-state-vertical',
  imports: [MatIconModule, MatButtonModule, NgTemplateOutlet],
  host: {
    class: 'flex items-center justify-center w-full flex-1',
  },
  styles: `
    .empty-state__fab-btn-container {
      border-radius: 50px;
      background: var(--color-purple-01);
      box-shadow: none !important;
      pointer-events: none;
    }

    .error-state__fab-btn-container {
      border-radius: 50px;
      background: var(--color-red-01, #fde7e4);
      box-shadow: none !important;
      pointer-events: none;
    }
  `,
  template: `
    <div class="flex flex-col gap-6 items-center p-6">
      @if (iconString()) {
        @if (enableFab()) {
          <button
            matFab
            disableRipple
            [disabledInteractive]="true"
            [class.empty-state__fab-btn-container]="
              stateType() === 'EMPTY_STATE'
            "
            [class.error-state__fab-btn-container]="
              stateType() === 'ERROR_STATE'
            "
          >
            <ng-container
              [ngTemplateOutlet]="svgIconRef"
              [ngTemplateOutletContext]="{ svgIcon: iconString() }"
            />
          </button>
        } @else {
          <ng-container
            [ngTemplateOutlet]="svgIconRef"
            [ngTemplateOutletContext]="{ svgIcon: iconString() }"
          />
        }
      }
      <section class="w-full flex flex-col gap-6 items-center!">
        <h6 class="title-medium">{{ title() }}</h6>
        <p class="body-large text-center!">{{ description() }}</p>
      </section>
    </div>

    <ng-template #svgIconRef let-svgIcon="svgIcon">
      <mat-icon
        [svgIcon]="svgIcon"
        [class.text-blue-15!]="stateType() === 'EMPTY_STATE'"
        [class.text-red-12!]="stateType() === 'ERROR_STATE'"
      />
    </ng-template>
  `,
})
export class EmptyStateVerticalComponent {
  readonly iconString = input<string>();
  readonly enableFab = input<boolean>(false);

  readonly stateType = input<'EMPTY_STATE' | 'ERROR_STATE'>('EMPTY_STATE');

  readonly title = input<string>();
  readonly description = input<string>();
}
